module.exports = __webpack_public_path__ + "static/media/online_mic.5c3c03f6.svg";